var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"updates-container"},[(_vm.Text)?_c('v-btn',{attrs:{"color":"accent","disabled":!_vm.Updated},on:{"click":_vm.Refresh}},[_c('span',[_vm._v(_vm._s(_vm.Text))])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }